export default {
  seo: {
    title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами | Банк 131',
    description: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами'
  },
  title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами',
}